<template>
  <div class="wrap-box">

    <div class="wrap-box-left">
      <div class="table-top-box">
        <span class="fl left">{{ $t('label.enterprisePage.detail.title') }}</span>
        <span class="fr right" @click="$router.back()"><Icon style="color:#1e98d3;font-size: 20px;"
                                                             type="ios-arrow-back"/>{{ $t('buttons.back') }}</span>
<!--        <span class="fr right"><span class="pdf-back"></span>导出PDF</span>-->
        <span class="fr right"><Icon :type="enterpriseDetail.favStatus ? 'md-star' : 'md-star-outline'" color="#008bce"
                                     style="font-size: 20px;" @click="editFavorite"/></span>
      </div>
      <div style="position:relative;">
        <Spin v-if="showSpin" fix></Spin>
        <el-card class="box-card pbr-enterprise-detail-header-title" style="overflow: scroll;margin:5px"
                 v-if="enterpriseDetail.name">
          <div slot="header" class="clearfix pbr-enterprise-detail-header-title">
            <h2 class="cp-title">{{ enterpriseDetail.name | filterEmpty }}</h2>
          </div>
          <Tabs>
            <TabPane :label="$t('label.enterprisePage.detail.basicInformation')">
              <description>
                <description-item :label="$t('label.enterprisePage.detail.unifiedCreditCode')" :spanMap="{ md: 12, sm:12, xs: 24}" :value="enterpriseDetail.code | filterEmpty"/>
                <description-item :label="$t('label.enterprisePage.detail.operatingStatus')" :spanMap="{ md: 12, sm:12, xs: 24}" :value="enterpriseDetail.bussinessStatus | filterEmpty"/>
                <description-item :label="$t('label.enterprisePage.detail.legalRepresentative')" :spanMap="{ md: 12, sm:12, xs: 24}" :value="enterpriseDetail.legalPerson | filterEmpty"/>
                <description-item :label="$t('label.enterprisePage.detail.dateOfEstablishing')" :spanMap="{ md: 12, sm:12, xs: 24}" :value="enterpriseDetail.createTime | filterEmpty"/>
                <description-item :label="$t('label.enterprisePage.detail.companyType')" :spanMap="{ md: 12, sm:12, xs: 24}" :value="enterpriseDetail.enterpriseType | filterEmpty"/>
                <description-item :label="$t('label.enterprisePage.detail.province')" :spanMap="{ md: 12, sm:12, xs: 24}" :value="enterpriseDetail.province | filterEmpty"/>
                <description-item :label="$t('label.enterprisePage.detail.usedName')" :spanMap="{ md: 12, sm:12, xs: 24}" :value="enterpriseDetail.formerName | filterEmpty"/>
                <description-item :label="$t('label.enterprisePage.detail.registrationAuthority')" :spanMap="{ md: 12, sm:12, xs: 24}" :value="enterpriseDetail.hierarchicalOrgan | filterEmpty"/>
                <description-item :label="$t('label.enterprisePage.detail.englishName')" :spanMap="{ md: 12, sm:12, xs: 24}" :value="enterpriseDetail.nameEn | filterEmpty"/>
                <description-item :label="$t('label.enterprisePage.detail.contactNumber')" :spanMap="{ md: 12, sm:12, xs: 24}" :value="enterpriseDetail.connectPhone | filterEmpty"/>
                <description-item class="pbr-enterprise-detail-desc" :label="$t('label.enterprisePage.detail.natureOfBusiness')" :span="24"
                                  :value="enterpriseDetail.bussinessScope | filterEmpty"/>
              </description>
            </TabPane>
          </Tabs>
        </el-card>
        <div class="clearfix pbr-enterprise-detail-header-title" v-else>
          <h2 class="cp-title">{{ $route.query.name | filterEmpty }}</h2>
          <span style="display: block;margin: 0 auto;width: 160px;">{{ noCompanyInfo }}</span>
        </div>
        <div class="cp-subtitle">{{ $t('label.enterprisePage.detail.projectList') }}</div>
        <Table :columns="columns" :data="referenceTableData" border
               @on-sort-change="projectListTableSortChange">
<!--          <template slot="favorites" slot-scope="{ row }">-->
<!--            <Icon v-if="row.favorites" style="font-size: 20px;cursor:pointer;" type="md-star"/>-->
<!--            <Icon v-else style="font-size: 20px;cursor:pointer;" type="md-star-outline"/>-->
<!--          </template>-->
          <template slot-scope="{ row }" slot="favorites">
            <Icon color="#008acd" @click="editProjectFavorite(row)" :type="row.focue ? 'md-star' : 'md-star-outline'"
                  style="font-size: 20px;cursor: pointer"/>
          </template>
          <template slot-scope="{ row }" slot="title">
            <span style="cursor:pointer" @click.stop="jumpProjectDetail(row)">{{ row.title }}</span>
            <!-- <a href="javascript:void(0)" @click="jumpProjectDetail(row)">{{ row.title}}</a> -->
          </template>
        </Table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :pager-count="5"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableTotal"
          style="margin: 10px 0;">
        </el-pagination>
      </div>
    </div>
    <div class="wrap-box-right">
      <div>
        <div class="pbr-title">{{ $t('label.enterprisePage.detail.enterpriseAtlas') }}</div>
        <div style="height: 400px;">
          <atlas-analysis id="enterpriseAlas" :graph="graphData"></atlas-analysis>
        </div>
      </div>
      <div>
        <div class="pbr-title">{{ $t('label.enterprisePage.detail.relevantInformation') }}</div>
        <normal-list :columns="['title','articleDate']" :data="aInfosModels" goto="pbrInfoDetail"></normal-list>
      </div>
    </div>
  </div>
</template>

<script>
import NormalList from '../index/NormalList.vue'
import Description from '../components/ElDescription.vue'
import DescriptionItem from '../components/ElDescriptionItem.vue'
import AtlasAnalysis from '../analysis/AtlasAnalysis'

export default {
  name: 'pbrCompanyDetail',
  components: {AtlasAnalysis, NormalList, Description, DescriptionItem},
  data () {
    let self = this
    return {
      graphData:{
        graph:{
        }
      },
      showSpin:true,
      enterpriseDetail:{},
      referenceTableData:[],
      currentPage: 1,
      pageSize: 10,
      tableTotal: 0,
      aInfosModels:[],
      columns: [
        // {
        //   type: 'selection',
        //   width: 40,
        //   align: 'center'
        // },
        // {
        //   title: ' ',
        //   width: 40,
        //   slot: 'favorites',
        //   align: 'center'
        // },
        {
          title: this.$t('table.project.main.title'),
          slot: 'title',
          tooltip: true,
          minWidth:200,
          className:'table-head-style',
          renderHeader:(h,params)=>{
            return h('span', {
              style: {
                textAlign: 'center'
              }
            }, params.column.title)
          }
        },
        {
          title: this.$t('table.project.main.amount'),
          key: 'buildSign',
          width: 130,
          align: 'right',
          // sortable: true
        },
        {
          title: this.$t('table.project.main.industry'),
          key: 'industryName',
          width: 120,
          align: 'center',
          // tooltip: true
          // sortable: true
        },
        {
          title: this.$t('table.project.main.state'),
          key: 'stageName',
          align: 'center',
          width: 100,
          // sortable: true
        },
        {
          title: this.$t('table.project.main.country'),
          key: 'countryName',
          width: 100,
          // sortable: true
        },
        {
          title: this.$t('table.project.main.date'),
          key: 'signDate',
          align: 'center',
          width: 100,
          // sortable: true,

          render: (h, params) => {
            return h('span', params.row.signDate ? self.$moment(params.row.signDate).isValid() ? self.$moment(params.row.signDate).format('yyyy-MM-DD') : params.row.signDate : '--')
          }
        }
      ],
      noCompanyInfo:''
    }
  },
  created () {
    // if (this.$route.query.key) {
    // this.fetchDetail()
    // this.fetchEnterprisePInfos()
    // // this.fetchEnterprisePStatistic()
    // this.fetchEnterpriseAInfo()
    // } else {
    //   this.$router.replace({name: 'pbrProject'})
    // }
  },
  mounted () {

  },
  activated () {
    if (this.$route.query.key) {
      this.reset()
      this.fetchDetail()
      this.fetchEnterprisePInfos()
      this.fetchEnterpriseAInfo()
      this.fetchGraphData()
    }else{
      //this.$iMessage.error({content: '没有获取详情所需id信息哦-图谱', duration: 5})
    }
  },
  methods: {
    reset () {
      this.enterpriseDetail = {}
      this.referenceTableData = []
      this.projectData = []
      this.aInfosModels = []
      this.graphData.graph = {}
    },
    /**
     * 企业图谱
     */
    fetchGraphData(){
      if (!this.$route.query.key) {
        return
      }
      this.$pbrApis.getRelationMapEnterprise({id: this.$route.query.key, conceptId:'4', tag:'1'}).then(res => {
        console.log('图谱', res)
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
        } else if (res.success) {
          this.graphData.graph = res.result
        }
      })
    },
    /**
     * 获取详情
     */
    fetchDetail () {
      // if (!this.$route.query.key) {
      //   this.$iMessage.error({content: '没有获取企业详情所需id信息哦', duration: 5})
      //   return
      // }
      // this.$pbrApis.queryEnterpriseDetail({id: this.$route.query.key, from: 'cn'}).then(res => {
      //   console.log('企业资讯详情', res)
      //   if (!res) {
      //     this.$iMessage.error({content: '服务器错误-企业资讯详情', duration: 5})
      //   } else if (res.success) {
      this.$pbrApis.fetchEnterpriseByName({keywords: this.$route.query.name, id: this.$route.query.key}).then(resp => {
        if (resp.success) {
          if(resp.result.hasOwnProperty('name') && resp.result.name !== ""){
            this.enterpriseDetail = resp.result
          }else{
            this.noCompanyInfo = this.$t('label.enterprisePage.detail.noCompanyInfo')
          }
        }else{
          this.noCompanyInfo = this.$t('label.enterprisePage.detail.noCompanyInfo')
        }
      }).finally(()=>{
        this.showSpin = false
      })
      // }
      // })
    },
    /**
     * 相关资讯
     * @param params
     */
    fetchEnterprisePInfos (params) {
      // this.$pbrApis.fetchEnterprisePInfos({
      //   id: this.$route.query.key,
      //   currentpage: 1,
      //   pagesize: 20,
      //   from: 'cn'
      // }).then(res => {
      //   console.log('项目列表接口', res)
      //   if (!res) {
      //     this.$iMessage.error({content: '服务器错误-项目列表接口', duration: 5})
      //   } else if (res.success) {
      //     this.referenceTableData = res.result.models
      //   }
      // })
      if (!this.$route.query.key) {
        return
      }
      let self = this
      this.$pbrApis.getProjectByEnterprise({
        id: this.$route.query.key,
        ...params,
        currentpage: this.currentPage,
        pagesize: this.pageSize,
        from: 'cn'
      }).then(res => {
        console.log('项目列表接口', res)
        if (!res) {
          this.tableTotal = 0
          this.tableData = []
          //self.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
        } else if (res.code === 200) {
          self.referenceTableData = res.result.records
          this.tableTotal = res.result.total
        }
      })
    },
    projectListTableSortChange (options) {
      let {column, key, order} = options
      // 综合：zh 金额：je  行业：hy  状态：zt   国家：gj   日期：rq   默认是综合
      let orderkeyEnum = {
        'amount': 'je',
        'industry': 'hy',
        'pubDate': 'rq',
        'status': 'zt',
        'country': 'gj'
      }
      let params = {}
      params.orderby = order
      params.orderkey = orderkeyEnum[key]
      this.fetchEnterprisePInfos(params)
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.fetchEnterprisePInfos()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchEnterprisePInfos()
    },
    fetchEnterprisePStatistic () {
      if (!this.$route.query.key) {
        return
      }
      let params ={"from":"cn","pageNo":0,"pageSize":10,"enterprises":[],"enterpriseStr":"","sort":0,"enterprisesId":this.$route.query.key}
      this.$pbrApis.fetchEnterprisePStatistic(params).then(res => {
        console.log('项目数据统计接口', res)
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
        } else if (res.success) {
          this.projectData = res.result
        }
      })
    },
    fetchEnterpriseAInfo () {
      if (!this.$route.query.key) {
        return
      }
      this.$pbrApis.fetchCompanyNewsList({enterpriseId: this.$route.query.key, from: 'cn',pageSize:5, pageNo: 0}).then(res => {
        console.log('相关资讯接口', res)
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
        } else if (res.success) {
          this.aInfosModels = res.result.content
        }
      })
    },
    editFavorite () {
      if (!this.$route.query.key) {
        //this.$iMessage.error({content: this.$t('message.waring.noFavorate'), duration: 5})
        return
      }
      let type = this.enterpriseDetail.favStatus ? 'delete' : 'add'
      this.$pbrApis.editFavorite(type, {id: this.$route.query.key, type: 2, userId: 1}).then(res => {
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.favorate'), duration: 5})
        } else if (res.code === 200) {
          console.log('收藏', res)
          //this.$iMessage.success({content: type === 'add' ? this.$t('message.success.favorate') : this.$t('message.success.unfavored'), duration: 5})
          this.fetchDetail()
        }
      }).catch(err => {
        //this.$iMessage.error({content: err.message, duration: 5})
      })
    },
    jumpProjectDetail (row) {
      this.$router.push({
        name: 'pbrProjectDetail',
        params: row,
        query: {key: row.id}
      })
    },
    editProjectFavorite (row) {
      let type = row.focue ? 'delete' : 'add'
      this.$pbrApis.editFavorite(type, {id: row.id, type: 3, userId: 1}).then(res => {
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.favorate'), duration: 5})
        } else if (res.code === 200) {
          console.log('收藏', res)
          //this.$iMessage.success({content: type === 'add' ? this.$t('message.success.favorate') : this.$t('message.success.unfavored'), duration: 5})
          this.reset()
          this.fetchDetail()
          this.fetchEnterprisePInfos()
          this.fetchEnterpriseAInfo()
        }
      }).catch(err => {
        //this.$iMessage.error({content: err.message, duration: 5})
      })
    }
  },
  watch: {},
  filters: {
    filterEmpty: function (value) {
      if (!value || value.length === 0) {
        return '--'
      }
      return value
    }
  }

}
</script>
<style scoped>
/deep/ .ivu-table-tip {
  overflow: hidden;
}

.pbr-enterprise-detail-desc >>> .default-value {
  overflow: visible !important;
  text-overflow: inherit !important;
  word-wrap: normal !important;
  white-space: normal !important;
}

>>> .descriptions-item-label {
  background-color: transparent !important;
  min-width:188px !important;
}

>>> .el-card {
  background-color: transparent;
}

>>> .el-card__header {
  padding: 1px 20px;
  border-bottom: none;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
  z-index: 999;
}

>>> .el-card__body {
  padding: 5px 20px;
}

>>> .ivu-table th.table-head-style{
  text-align: center;
}
>>> .ivu-table-tbody span {
  word-break: break-word;
}
</style>
